<template>
  <div style="background:#fff;">
    <header-info cur="1"></header-info>
    <div class="center">
      <div class="list">
        <div class="pic-wrap">
          <img
            :src="studentInfo && studentInfo.lessonOnline && studentInfo.lessonOnline.logoPath ? studentInfo.lessonOnline.logoPath : ''"
            :onerror="$store.state.defaultImg"
            alt=""
          >
        </div>
        <div class="desc-wrap">
          <p class="p1">{{ studentInfo && studentInfo.lessonOnline ? studentInfo.lessonOnline.title : '' }}</p>
          <p class="p2">
            <span>{{ studentInfo && studentInfo.onlineClass ? studentInfo.onlineClass.title : '' }}</span>
            <span>{{ studentInfo && studentInfo.lessonOnline && studentInfo.lessonOnline.manager ? studentInfo.lessonOnline.manager.name : '' }}</span>
          </p>
          <div class="progress-time">
            <div class="progress-bg">
              <div
                class="skills progress"
                :style="`width:${ studentInfo ? studentInfo.progressWidth : '0'}%`"
              ></div>
            </div>
            <div>
              {{ studentInfo ? studentInfo.currentWeek : '' }}/
              <span v-if="studentInfo">{{ studentInfo && studentInfo.lessonOnline && studentInfo.lessonOnline.allTime ? studentInfo.lessonOnline.allTime : '--' }}</span>
              周
            </div>
          </div>

        </div>
      </div>
      <ul class="switch-tab">
        <li
          :class="active==1?'active':''"
          @click="active=1,changeNav(1)"
        >学习列表
        </li>
        <li
          :class="active==2?'active':''"
          @click="active=2,changeNav(2)"
        >课程简介
        </li>
        <li
          :class="active==3?'active':''"
          @click="active=3,changeNav(3)"
        >讨论答疑
        </li>
        <li
          :class="active==4?'active':''"
          @click="active=4,changeNav(4),getStudyProgress()"
        >学习进度
        </li>
        <li
          :class="active==5?'active':''"
          @click="active=5,changeNav(5)"
        >调查问卷
        </li>
      </ul>
      <!-- 学习列表 -->
      <div
        class="content"
        v-show="active==1"
      >
        <div class="container-wrap">
          <div class="menu-list">
            <!-- 标签 -->
            <!-- 列表 -->
            <div class="field">
              <span class="list-title">预习</span>
              <ul
                class="field-column"
                v-if="listData.length"
              >
                <div
                  v-for="(item, index) in listData"
                  :key="index"
                >
                  <li
                    class="field-item"
                    @click="onFieldClick(item)"
                    v-if="item.preview==0"
                  >
                    <img
                      :src="FunIcont(item)"
                      alt=""
                    >
                    <span class="name">{{item.title?item.title:item.experiment.title}}</span>
                    <span
                      v-show="FunTagName(item)"
                      class="label"
                      :class="FunTagColor(item)?'expBg':'theoryBg'"
                    >{{FunTagName(item)}}</span>
                  </li>
                </div>
              </ul>
              <span class="list-title">学习内容</span>
              <ul
                class="field-column"
                v-if="listData.length"
              >
                <div
                  v-for="(item, index) in listData"
                  :key="index"
                >
                  <li
                    class="field-item"
                    @click="onFieldClick(item)"
                    v-if="item.preview==1"
                  >
                    <img
                      :src="FunIcont(item)"
                      alt=""
                    >
                    <span class="name">{{item.title?item.title:item.experiment.title}}</span>
                    <span
                      v-show="FunTagName(item)"
                      class="label"
                      :class="FunTagColor(item)?'expBg':'theoryBg'"
                    >{{FunTagName(item)}}</span>
                  </li>
                </div>
              </ul>
              <span class="list-title">测试</span>
              <ul
                class="field-column"
                v-if="listData.length"
              >
                <div
                  v-for="(item, index) in listData"
                  :key="index"
                >
                  <li
                    class="field-item"
                    @click="onFieldClick(item)"
                    v-if="item.preview!=0 && item.preview!=1"
                  >
                    <img
                      :src="FunIcont(item)"
                      alt=""
                    >
                    <span class="name">{{item.title?item.title:item.experiment.title}}</span>
                    <span
                      v-show="FunTagName(item)"
                      class="label"
                      :class="FunTagColor(item)?'expBg':'theoryBg'"
                    >{{FunTagName(item)}}</span>
                  </li>
                </div>
              </ul>
              <div
                v-else
                class="tips"
              >
                暂无内容
              </div>
            </div>
          </div>
          <div class="sub-group">
            <StudyExp
              :ItemObject="ItemObject"
              v-if="subgroupIndex == 1"
            />
            <Test
              :ItemObject="ItemObject"
              v-if="subgroupIndex == 2"
            />
          </div>
        </div>
      </div>
      <!-- 课程简介 -->
      <div
        class="content brief"
        v-show="active==2"
      >

        <div
          v-if="studentInfo.lessonOnline"
          v-html="studentInfo.lessonOnline.brief"
        ></div>
        <div
          v-else
          class="noitems"
        >没有数据
        </div>
      </div>
      <!-- 讨论答疑 -->
      <div
        class="content discuss"
        v-show="active==3"
      >
        <div v-show="isShowReply==2">
          <div class="operation">
            <div class="operation-left">
              <div class="operation-tab">
                <div
                  :class="discussActive==2?'active':''"
                  @click="discussActive=2,changeDiscussActive(2)"
                >讨论
                </div>
                <div
                  :class="discussActive==1?'active':''"
                  @click="discussActive=1,changeDiscussActive(1)"
                >答疑
                </div>
              </div>
              <div class="operation-search">
                <input
                  type="text"
                  placeholder="帖子名称"
                  v-model="discussQueryInfo.title"
                >
                <span @click="getDiscussList">搜索</span>
              </div>
            </div>
            <div
              class="operation-btn"
              @click="showAddWindow"
            >
              添加帖子
            </div>
          </div>
          <div
            class="discuss-content"
            v-if="discussData.length"
          >
            <div
              class="posts"
              v-for="(item,index) in discussData"
              :key="index"
            >
              <h6 @click="showReply(item)">{{ item.title }}</h6>
              <div class="posts-info">
                <div>
                  <span>{{ item.createUser ? item.createUser.name : '--' }}</span>
                  <span>{{ item.pubDate ? item.pubDate.replace('T', ' ') : '--' }}</span>
                </div>
                <span></span>
              </div>
            </div>
          </div>
          <div
            v-else
            class="noitems"
          >没有数据
          </div>
        </div>
        <!-- 讨论答疑回复 -->
        <div
          class="discuss-reply"
          v-show="isShowReply==1"
        >
          <div class="discuss-main">
            <div class="discuss-main-title">
              <span>{{ discussItemInfo.title }}</span>
              <!--              <div-->
              <!--                class="praise"-->
              <!--                @click="inPostsParise(discussItemInfo.id)"-->
              <!--              >-->
              <!--                <i class="iconfont">&#xe600;</i>-->
              <!--                <span>赞({{discussItemInfo.count?discussItemInfo.count:0}})</span>-->
              <!--              </div>-->
            </div>
            <div
              class="discuss-main-content"
              v-html="discussItemInfo.content"
            ></div>
            <div class="discuss-main-tips">
              <div>
                <span>{{ discussItemInfo.createUser ? discussItemInfo.createUser.name : '--' }}</span>
                <span>{{ discussItemInfo.pubDate ? discussItemInfo.pubDate.replace('T', ' ') : '--' }}</span>
              </div>
              <span @click="showPostsWindow(0,discussItemInfo)">回复</span>
            </div>
            <div
              class="discuss-main-count"
              v-if="replyListData.length"
            >共有{{ replyListData.length }}条回复
            </div>
          </div>
          <ul class="posts-info">
            <li
              v-for="(item,index) in replyListData"
              :key="index"
            >
              <div
                class="reply-main"
                v-if="item.discussType==1"
              >
                <div>
                  <i class="iconfont icon-left">&#xe63d;</i>
                  <div>
                    <p>{{ item.oriUser }}发表于{{ formatDate(item.oriCreated) }}</p>
                    <p v-html="item.oriContent"></p>
                  </div>
                  <i class="iconfont icon-right">&#xe63e;</i>
                </div>
              </div>
              <div
                class="posts-info-content"
                v-html="item.content"
              ></div>
              <div class="posts-info-tips">
                <div>
                  <span>{{ item.createUser }}</span>
                  <span>{{ formatDate(item.created) }}</span>
                </div>
                <div>
                  <!--                  <div-->
                  <!--                    class="praise"-->
                  <!--                    @click="inParise(item.id)"-->
                  <!--                  >-->
                  <!--                    <i class="iconfont">&#xe600;</i>-->
                  <!--                    <span>赞({{item.count}})</span>-->
                  <!--                  </div>-->
                  <span
                    class="reply"
                    @click="showPostsWindow(1,item)"
                  >回复</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- 学习进度 -->
      <div
        class="content study-speed"
        v-show="active==4"
      >

        <ul class="section">
          <li>
            <div class="section-title">
              <span>预习</span>
              <div class="progress-bg">
                <span>{{getCount(studyProcessData.preview).toFixed(2)}}%</span>
                <div
                  class="skills progress"
                  :style="`width:${getCount(studyProcessData.preview)}%`"
                ></div>
              </div>
            </div>
            <div>
              <div
                class="section-discuss"
                v-for="item in studyProcessData.preview"
                :key="item.id"
              >
                <div>
                  <i
                    class="iconfont"
                    :style="`${item.finished?'color:#25b864':''}`"
                  >{{item.finished?'&#xe64d;':'&#xe64e;'}}</i>
                  <span style="color:#019999">【{{item.studyType?'实验预习':'理论预习'}}】</span>
                  <span>{{item.title}}</span>
                </div>
              </div>
              <div
                class="section-discuss no-more"
                v-if="!studyProcessData.preview.length"
              >
                暂无数据
              </div>
            </div>
          </li>
          <li>
            <div class="section-title">
              <span>学习</span>
              <div class="progress-bg">
                <span>{{getCount(studyProcessData.study).toFixed(2)}}%</span>
                <div
                  class="skills progress"
                  :style="`width:${getCount(studyProcessData.study)}%`"
                ></div>
              </div>
            </div>
            <div>
              <div
                class="section-discuss"
                v-for="item in studyProcessData.study"
                :key="item.id"
              >
                <div>
                  <i
                    class="iconfont"
                    :style="`${item.finished?'color:#25b864':''}`"
                  >{{item.finished?'&#xe64d;':'&#xe64e;'}}</i>
                  <span style="color:#019999">【{{item.studyType?'实验学习':'理论学习'}}】</span>
                  <span>{{item.title}}</span>
                </div>
              </div>
              <div
                class="section-discuss  no-more"
                v-if="!studyProcessData.study.length"
              >
                暂无数据
              </div>
            </div>
          </li>
          <li>
            <div class="section-title">
              <span>测试</span>
              <div class="progress-bg">
                <span>{{getCount(studyProcessData.exam).toFixed(2)}}%</span>
                <div
                  class="skills progress"
                  :style="`width:${getCount(studyProcessData.exam)}%`"
                ></div>
              </div>
            </div>
            <div>
              <div
                class="section-discuss"
                v-for="item in studyProcessData.exam"
                :key="item.id"
              >
                <div>
                  <i
                    class="iconfont"
                    :style="`${item.finished?'color:#25b864':''}`"
                  >{{item.finished?'&#xe64d;':'&#xe64e;'}}</i>
                  <span style="color:#019999">【{{item.studyType?'实验测试':'理论测试'}}】</span>
                  <span>{{item.title}}</span>
                </div>
                <div class="grade">
                  <span>得分：{{item.grade?item.grade:'--'}}</span>
                </div>
              </div>
              <div
                class="section-discuss  no-more"
                v-if="!studyProcessData.exam.length"
              >
                暂无数据
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- 调查问卷 -->
      <div
        class="content study-speed"
        v-show="active==5"
      >
        <div
          class="list-question"
          v-if="survey_id && finishedSurveyIds.indexOf(survey_id) < 0"
        >
          <h2>{{ surveyInfo ? surveyInfo.title : '' }}</h2>
          <hr>
          <ul>
            <li
              v-for="(question, index) in questions"
              :key="index"
            >
              <div>
                <span class="question-title">{{ index + 1 }}.</span>
                <span
                  class="question-title"
                  v-html="question.content"
                ></span>
              </div>
              <div>
                <ul class="question-list">
                  <li
                    v-for="(option, op_index) in question.options"
                    :key="op_index"
                  >
                    <input
                      type="radio"
                      v-if="question.questionType == 1"
                      :name="'' + question.id + '_' + option.id"
                      @click="surveyRadClick(question, option)"
                      :checked="question.selectOption.indexOf(option.code) >= 0"
                    >
                    <input
                      type="checkbox"
                      v-if="question.questionType == 2"
                      :name="'' + question.id + '_' + option.id"
                      @click="surveyCkClick(question, option)"
                      :checked="question.selectOption.indexOf(option.code) >= 0"
                    >
                    {{ option.code }}. {{ option.title }}
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div
          class="footer-btn"
          v-if="survey_id && finishedSurveyIds.indexOf(survey_id) < 0"
        >
          <div
            class="add-btn"
            @click="saveStudentSurvey"
          >提交</div>
        </div>
        <div
          class="footer-btn"
          v-if="survey_id && finishedSurveyIds.indexOf(survey_id) >= 0"
        >
          调查问卷已提交！
        </div>
      </div>
    </div>
    <div
      id="south"
      ref="south"
    >
      <footer-info></footer-info>
    </div>
    <!-- 新增帖子弹窗 -->
    <div
      class="form_overlay"
      :style="classShowAddWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel editor">
        <div class="form_title">帖子</div>
        <div class="form_content">
          <form>
            <div class="item">
              <span class="label"><i class="require">*</i>标题:</span>
              <input type="hidden">
              <input
                type="text"
                v-model="formInfo.title"
                maxlength="25"
              >
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>分类:</span>
              <select
                id=""
                v-model="formInfo.disType"
              >
                <option value="1">答疑</option>
                <option value="2">讨论</option>
              </select>
            </div>
            <div class="item">
              <div class="k-container1 ">
                <vue-ueditor-wrap
                  :config="editorConfig"
                  v-model="formInfo.content"
                  editor-id="editor-demo-3"
                ></vue-ueditor-wrap>
              </div>
            </div>
            <div class="clearfix"></div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            @click="hideAddWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            @click="addDiscussInfo"
          >提交</a>
        </div>
      </div>
    </div>
    <!-- 帖子回复弹窗 -->
    <div
      class="form_overlay"
      :style="classShowPostsWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel editor">
        <div class="form_title">帖子回复</div>
        <div class="form_content">
          <form>
            <div
              class="reply-main"
              v-if="replyInfo.discussType==1"
            >
              <div>
                <i class="iconfont icon-left">&#xe63d;</i>
                <div>
                  <p>{{ replyInfo.oriUser }}发表于{{ formatDate(replyInfo.oriCreated) }}</p>
                  <p v-html="replyInfo.oriContent"></p>
                </div>
                <i class="iconfont icon-right">&#xe63e;</i>
              </div>
            </div>
            <div class="item">
              <div class="k-container1 ">
                <vue-ueditor-wrap
                  :config="editorConfig"
                  v-model="replyInfo.content"
                  editor-id="editor-demo-1"
                ></vue-ueditor-wrap>
              </div>
            </div>
            <div class="clearfix"></div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            @click="hidePostsWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            @click="addDiscussReplyInfo"
          >提交</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderInfo from '../../../components/HeaderInfo'
import FooterInfo from '../../../components/FooterInfo'
import VueUeditorWrap from 'vue-ueditor-wrap'
import StudyExp from '../../../components/MyLessonStudy/MyLessonStudyExp' // 学习及实验
import Test from '../../../components/MyLessonStudy/MyLessonStudyTest' // 测试

// 图标
import study from '../../../assets/images/lessonStudy/study.png'
import studyHover from '../../../assets/images/lessonStudy/study_hover.png'
import exp from '../../../assets/images/lessonStudy/exp.png'
import expHover from '../../../assets/images/lessonStudy/exp_hover.png'
import task from '../../../assets/images/lessonStudy/task.png'
import taskHover from '../../../assets/images/lessonStudy/task_hover.png'
import testImg from '../../../assets/images/lessonStudy/testImg.png'
import testImgHover from '../../../assets/images/lessonStudy/testImg_hover.png'
import talk from '../../../assets/images/lessonStudy/talk.png'
import talkHover from '../../../assets/images/lessonStudy/talk_hover.png'
import answer from '../../../assets/images/lessonStudy/answer.png'
import answerHover from '../../../assets/images/lessonStudy/answer_hover.png'
import up from '../../../assets/images/lessonStudy/up.png'
import down from '../../../assets/images/lessonStudy/down.png'

export default {
  name: 'MyLessonDetail',
  components: {
    HeaderInfo,
    FooterInfo,
    VueUeditorWrap,
    StudyExp,
    Test
  },
  data() {
    return {
      isShowReply: 2,
      active: 1,
      discussActive: 2,
      discussData: [], // 讨论答疑数据
      progressData: [], // 学习进度数据
      classShowAddWindow: {},
      classShowPostsWindow: {},
      studentInfo: {},
      queryInfo: {
        page: 1,
        size: 10,
        lessonOnline_id: this.$route.query.id
      },
      editorConfig: {
        // 访问 UEditor 静态资源的根路径，可参考 https://hc199421.gitee.io/vue-ueditor-wrap/#/faq
        UEDITOR_HOME_URL: '/UE/',
        // 服务端接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        // serverUrl: '//ueditor.szcloudplus.com/cos',
        serverUrl: this.$store.state.uEditorServerUrl,
        autoHeight: true,
        // imagePathFormat: '/files/{yyyy}{mm}{dd}-{time}{rand:6}',
        // imageUrlPrefix: 'http://localhost:8000'
        initialFrameWidth: '100%',

        initialFrameHeight: 300
      },
      // 讨论答疑新增帖子所用数据
      formInfo: {
        title: '',
        disType: '',
        content: '',
        pubDate: '',
        lessonOnline_id: this.$route.query.id
      },
      // 回复帖子所用数据
      replyInfo: {
        // studentDiscuss_id: '',
        onlineDiscuss_id: '',
        userProfile_id: '',
        content: '',
        createUser: '',
        oriUser: '',
        oriContent: '',
        oriCreated: '',
        discussType: ''
      },
      discussItemInfo: {},
      // 讨论答疑搜索所用数据
      discussQueryInfo: {
        lessonOnline_id: this.$route.query.id,
        profile_id: this.$store.state.userInfo.profile_id,
        title: '',
        disType: 2,
        page: 1,
        size: 10000
      },
      replyListData: [],
      replyListDataCount: 0,
      pariseData: [],
      parisePostsData: [],

      studyData: [],
      examData: [],
      ItemObject: {}, // 组件传值
      subgroupIndex: 0, // 组件下标
      timer: null,
      // 图片
      study,
      studyHover,
      exp,
      expHover,
      task,
      taskHover,
      testImg,
      testImgHover,
      talk,
      talkHover,
      answer,
      answerHover,
      up,
      down,

      // 调查问卷
      survey_id: null,
      surveyInfo: null,
      allQuestion: [],
      allOption: [],
      questions: [],
      finishedSurveyIds: [],
      studyProcessData: {
        preview: [],
        study: [],
        exam: []
      },
      sensitiveWord: []
    }
  },
  computed: {

    listData () {
      const data = []
      for (let i = 0; i < this.studyData.length; i++) {
        this.$set(this.studyData[i], 'type', 1)
        this.$set(this.studyData[i], 'isActive', 0)
        data.push(this.studyData[i])
      }
      for (let i = 0; i < this.examData.length; i++) {
        this.$set(this.examData[i], 'type', 2)
        this.$set(this.examData[i], 'isActive', 0)
        data.push(this.examData[i])
      }
      return data
    }
  },
  methods: {
    async getStudyProgress() {
      const url = '/online_student_study_process/'
      await this.$http.get(url, {
        params: {
          onlineStudentId: this.$route.query.studentId
        }
      }).then((data) => {
        this.studyProcessData = data.data
      }).catch((error) => {
        console.log(error)
      })
    },
    getCount (item) {
      var sum = 0
      if (item) {
        for (let i = 0; i < item.length; i++) {
          sum = sum + item[i].finished
        }
        return item.length ? (sum / item.length).toFixed(2) * 100 : item.length
      } else {
        return 0
      }
    },
    // 格式化日期
    formatDate(value) {
      if (value.indexOf('.') < 0) {
        return value.replace('T', ' ')
      } else {
        return value.replace('T', ' ').substring(0, value.indexOf('.'))
      }
    },
    // 计算当前时间处于第几周
    getWeek(dt) {
      var _this = this
      const yy = new Date().getFullYear()
      const mm = new Date().getMonth() + 1
      const dd = new Date().getDate()
      _this.gettime = yy + '-' + mm + '-' + dd
      const d1 = new Date(dt) // 开始时间
      const d2 = new Date(_this.gettime) // 当前时间日期
      const rq = d2 - d1
      const days = Math.ceil(rq / (24 * 60 * 60 * 1000))
      const num = Math.ceil(days / 7)
      return num
    },
    // 显示新增帖子弹窗
    showAddWindow() {
      this.classShowAddWindow = { visibility: 'visible' }
    },
    // 隐藏新增帖子弹窗
    hideAddWindow() {
      this.classShowAddWindow = { visibility: 'hidden' }
      this.formInfo = {
        title: '',
        disType: '',
        content: '',
        pubDate: '',
        lessonOnline_id: this.$route.query.id
      }
    },
    // 显示帖子回复弹窗
    showPostsWindow(code, item) {
      this.replyInfo = {
        onlineDiscuss_id: this.discussItemInfo.id,
        userProfile_id: this.$store.state.profile_id,
        content: '',
        createUser: this.$store.state.userInfo.name,
        oriUser: item.createUser.name,
        oriContent: item.content,
        oriCreated: item.created,
        discussType: code
      }
      this.classShowPostsWindow = { visibility: 'visible' }
    },
    // 隐藏帖子回复弹窗
    hidePostsWindow() {
      this.classShowPostsWindow = { visibility: 'hidden' }
    },
    // 获取当前时间
    getCurrentTime() {
      var _this = this
      const yy = new Date().getFullYear()
      const mm = new Date().getMonth() + 1
      const dd = new Date().getDate()
      const hh = new Date().getHours()
      const mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
      const ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()
      _this.gettime = yy + '-' + mm + '-' + dd + 'T' + hh + ':' + mf + ':' + ss
      return _this.gettime
    },
    // 切换答疑/讨论
    changeDiscussActive(value) {
      this.discussQueryInfo.disType = value
      this.getDiscussList()
    },
    // 切换导航
    changeNav(value) {
      this.isShowReply = 2
      this.active = value
    },
    // 显示讨论答疑回复区域
    showReply(item) {
      this.isShowReply = 1
      this.discussItemInfo = item
      this.getDiscuss()
    },
    // 获取课程简介与学习评价数据
    async getOnlineStudent() {
      const params = {
        lessonOnline_id: this.queryInfo.lessonOnline_id,
        userProfile_id: this.$store.state.userInfo.profile_id
      }
      const url = '/online_student/' + this.$route.query.studentId + '/'
      await this.$http.get(url, { params }).then((data) => {
        data.currentWeek = data.lessonOnline.startTime ? this.getWeek(data.lessonOnline.startTime) : '--'
        if (data.lessonOnline.allTime) {
          data.progressWidth = (data.currentWeek / data.lessonOnline.allTime * 100).toFixed(2)
        } else {
          data.progressWidth = 0
        }
        this.studentInfo = data
      }).catch((error) => {
        console.log(error)
      })
    },
    // 获取讨论答疑数据
    async getDiscussList() {
      await this.$http.get('/online_discuss/', { params: this.discussQueryInfo }).then((data) => {
        this.discussData = data.results
      }).catch((error) => {
        console.log(error)
      })
    },

    // 新增帖子
    async addDiscussInfo() {
      if (this.formInfo.title === '') {
        this.$layer.msg('标题不能为空！')
        return
      }
      if (this.formInfo.disType === '') {
        this.$layer.msg('请选择分类！')
        return
      }
      if (this.formInfo.content === '') {
        this.$layer.msg('内容不能为空！')
        return
      }
      const isRight = this.utils.getWords(this.formInfo.content, this.sensitiveWord)
      if (isRight) {
        this.$layer.msg('输入的内容有敏感词!')
        return false
      }
      this.formInfo.pubDate = this.getCurrentTime()
      this.formInfo.createUser_id = this.$store.state.userInfo.profile_id
      await this.$http.post('/online_discuss/', this.formInfo).then((data) => {
        if (data.id) {
          this.$layer.msg('添加帖子成功！')
          this.getDiscussList()
          this.hideAddWindow()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    // 回复帖子
    async addDiscussReplyInfo() {
      this.replyInfo.createUser = this.$store.state.userInfo.name
      this.replyInfo.userProfile_id = this.$store.state.userInfo.profile_id
      this.replyInfo.onlineDiscuss_id = this.discussItemInfo.id
      if (this.replyInfo.content === '') {
        this.$layer.msg('回复的内容不能为空！')
        return
      }
      const isRight = this.utils.getWords(this.replyInfo.content, this.sensitiveWord)
      if (isRight) {
        this.$layer.msg('输入的内容有敏感词!')
        return false
      }
      await this.$http.post('/online_discuss_info/', this.replyInfo).then((data) => {
        this.hidePostsWindow()
        this.getDiscuss()
      }).catch((error) => {
        console.log(error)
      })
    },
    // 获取讨论答疑回复列表
    async getDiscuss() {
      var params = {
        onlineDiscuss_id: this.discussItemInfo.id
      }
      await this.$http.get('/online_discuss_info/', { params }).then((data) => {
        this.replyListData = data.results
        this.replyListDataCount = data.count
        this.getPostsParise()
        this.getParise()
      }).catch(() => {
        this.$layer.msg('获取列表信息失败！')
      })
    },
    // 检索当前评论用户是否点赞过此帖子
    async inPostsParise(InfoId) {
      var formInfo = {
        onlineDiscuss_id: InfoId,
        userProfile_id: this.studentInfo.id
      }
      await this.$http.get('/online_discuss_praise/', {
        params: formInfo
      }).then((data) => {
        if (!data.count) {
          this.SavePostsParise(formInfo)
        }
      }).catch(() => {
        this.$layer.msg('获取列表信息失败！')
      })
    },

    // 帖子点赞
    async getPostsParise() {
      var formInfo = {
        page: 1,
        size: 900000
      }
      await this.$http.get('/online_discuss_praise/', {
        params: formInfo
      }).then((data) => {
        this.parisePostsData = data.results
        for (let j = 0; j < this.parisePostsData.length; j++) {
          if (this.parisePostsData[j].onlineDiscuss_id === this.discussItemInfo.id && this.parisePostsData[j].onlineStudent_id === this.studentInfo.id) {
            this.discussItemInfo.count = 1
          }
        }
        this.$forceUpdate()
      }).catch(() => {
        this.$layer.msg('获取列表信息失败！')
      })
    },
    // 添加帖子点赞信息
    async SavePostsParise(formInfo) {
      await this.$http.post('/online_discuss_praise/', formInfo).then((data) => {
        if (data.id) {
          this.getPostsParise()
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('添加失败！')
      })
    },
    // 检索当前评论用户是否点赞过此评论
    async inParise(InfoId) {
      var formInfo = {
        studentDiscussInfo_id: InfoId,
        onlineStudent_id: this.studentInfo.id
      }
      await this.$http.get('/online_discuss_info_praise/', {
        params: formInfo
      }).then((data) => {
        if (!data.count) {
          this.SaveParise(formInfo)
        }
      }).catch(() => {
        this.$layer.msg('获取列表信息失败！')
      })
    },
    // 点赞
    async getParise() {
      var formInfo = {
        page: 1,
        size: 900000
      }
      await this.$http.get('/online_discuss_info_praise/', {
        params: formInfo
      }).then((data) => {
        this.pariseData = data.results
        var count = 0
        for (let i = 0; i < this.replyListData.length; i++) {
          for (let j = 0; j < this.pariseData.length; j++) {
            if (this.pariseData[j].studentDiscussInfo_id === this.replyListData[i].id) {
              count = count + 1
            }
          }
          this.$set(this.replyListData[i], 'count', count)
          // this.listData[i].count = count
          count = 0
        }
      }).catch(() => {
        this.$layer.msg('获取列表信息失败！')
      })
    },
    // 添加点赞信息
    async SaveParise(formInfo) {
      await this.$http.post('/online_discuss_info_praise/', formInfo).then((data) => {
        if (data.id) {
          this.getParise()
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('添加失败！')
      })
    },

    // 获取学习信息
    async getStudy () {
      await this.$http.get('/online_study/', {
        params: { // 节
          page: 1,
          size: 10000,
          status: 1,
          lessonOnline_id: this.$route.query.id
        }
      }).then((data) => {
        const previewStudy = []
        const normalStudy = []
        for (let i = 0; i < data.results.length; i++) {
          if (data.results[i].preview === 0) {
            previewStudy.push(data.results[i])
          } else {
            normalStudy.push(data.results[i])
          }
        }
        this.studyData = previewStudy.concat(normalStudy)
      })
    },
    async getExam () {
      await this.$http.get('/online_exam/', {
        params: {
          page: 1,
          size: 10000,
          status: 1,
          lessonOnline_id: this.$route.query.id
        }
      }).then((data) => {
        this.examData = data.results
      }).catch((error) => {
        console.log(error)
      })
    },
    // 匹配对应图标
    FunIcont(item) {
      var Icont = ''
      if (item.type === 1) {
        if (item.isActive === 0) {
          Icont = item.studyType ? exp : study
        } else {
          Icont = item.studyType ? expHover : studyHover
        }
      } else if (item.type === 2) {
        Icont = item.isActive ? testImgHover : testImg
      }
      return Icont
    },
    // 匹配对应标签
    FunTagName(item) {
      var TagName = ''
      if (item.type === 1) {
        TagName = item.studyType ? '实验' : ''
      } else if (item.type === 2) {
        TagName = '理论学习测试'
      }
      return TagName
    },
    // 匹配对应标签背景色
    FunTagColor(item) {
      var ColorType = ''
      if (item.type === 1) {
        ColorType = item.studyType
      } else if (item.type === 2) {
        ColorType = item.homeworkType
      } else if (item.type === 3) {
        ColorType = item.testType
      } else if (item.type === 4) {
        ColorType = item.disType === 1 ? 0 : 1
      }
      return ColorType
    },
    // 学习 点击事件
    onFieldClick (item) {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      // 重置isActive属性
      for (let i = 0; i < this.studyData.length; i++) {
        this.$set(this.studyData[i], 'isActive', 0)
      }
      for (let i = 0; i < this.examData.length; i++) {
        this.$set(this.examData[i], 'isActive', 0)
      }
      item.isActive = 1

      this.ItemObject = item // 给子组件传值
      this.subgroupIndex = item.type // 显示对应组件
      // 当点击是学习理论时
      if (item.type === 1 && item.studyType === 0) {
        // 改为30秒后 执行
        this.timer = setTimeout(() => {
          this.getStudentStudy(item.id)
        }, 30 * 1000)
      }
    },
    // 获取是否已完成学习
    async getStudentStudy(studyId) {
      await this.$http.get('/online_student_study/', {
        params: {
          onlineStudent_id: this.$route.query.studentId,
          onlineStudy_id: studyId
        }
      }).then((data) => {
        if (!data.count) {
          this.SaveStudentStudy(studyId)
        }
      }).catch(() => {
        this.$parent.showMsg('获取列表信息失败！')
      })
    },
    // 设置已完成
    async SaveStudentStudy(studyId) {
      await this.$http.post('/online_student_study/', {
        onlineStudent_id: this.$route.query.studentId,
        onlineStudy_id: studyId,
        percent: 100,
        status: 1
      }).then((data) => {
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('添加失败！')
      })
    },

    // 调查问卷
    async getSurveyInfo () {
      this.survey_id = null
      this.surveyInfo = null
      this.finishedSurveyIds = []

      await this.$http.get('/online_survey/', {
        params: {
          lessonOnline_id: this.$route.query.id,
          status: 1
        }
      }).then((data) => {
        if (data.results.length > 0) {
          this.surveyInfo = data.results[0]
          this.survey_id = data.results[0].id
        }
      })

      await this.$http.get('/online_student_survey/', {
        params: {
          lessonOnline_id: this.$route.query.id,
          userProfile_id: this.$store.state.userInfo.profile_id
        }
      }).then((data) => {
        if (data.results.length > 0) {
          for (let i = 0; i < data.results.length; i++) {
            this.finishedSurveyIds.push(data.results[i].onlineSurvey_id)
          }
        }
      })

      if (this.survey_id && this.finishedSurveyIds.indexOf(this.survey_id) < 0) {
        await this.$http.get('/online_survey_question/', {
          params: {
            page: 1,
            size: 10000,
            survey_id: this.survey_id
          }
        }).then((data) => {
          this.allQuestion = data.results
        })

        await this.$http.get('/online_survey_question_option/', {
          params: {
            page: 1,
            size: 10000,
            survey_id: this.survey_id
          }
        }).then((data) => {
          this.allOption = data.results
        })

        const data = []
        for (let i = 0; i < this.allQuestion.length; i++) {
          const question = this.allQuestion[i]
          question.options = []
          this.$set(question, 'selectOption', [])
          for (let j = 0; j < this.allOption.length; j++) {
            if (this.allOption[j].surveyQuestion_id === question.id) {
              question.options.push(this.allOption[j])
            }
          }
          data.push(question)
        }
        this.questions = data
      }
    },
    surveyRadClick(question, option) {
      question.selectOption = []
      question.selectOption.push(option.code)
    },
    surveyCkClick(question, option) {
      if (question.selectOption.indexOf(option.code) >= 0) {
        question.selectOption.splice(question.selectOption.indexOf(option.code), 1)
      } else {
        question.selectOption.push(option.code)
      }
      question.selectOption.sort()
    },
    async saveStudentSurvey () {
      for (let i = 0; i < this.questions.length; i++) {
        if (this.questions[i].selectOption.length === 0) {
          this.$layer.msg('请选择全部题目后再提交！')
          return false
        }
      }
      const data = {
        onlineStudent_id: this.$route.query.studentId,
        onlineSurvey_id: this.survey_id,
        questions: []
      }
      for (let i = 0; i < this.questions.length; i++) {
        data.questions.push({
          surveyQuestion_id: this.questions[i].id,
          selectOption: this.questions[i].selectOption
        })
      }
      await this.$http.post('/online_student_survey_save/', {
        json_data: JSON.stringify(data)
      }).then((data) => {
        if (data.code === '200') {
          this.$layer.msg('提交成功！')
          this.getSurveyInfo()
        } else {
          this.$layer.msg('提交失败！')
        }
      })
    },
    // 获取敏感词
    async getSensitiveWord() {
      await this.$http.get('/sensitiveword/', {
        params: {
          page: 1,
          size: 10000,
          status: 1
        }
      }).then((data) => {
        if (data.results.length) {
          data.results.forEach(item => {
            if (item.words) {
              const wordList = item.words.split('\n')
              for (let i = 0; i < wordList.length; i++) {
                this.sensitiveWord.push(wordList[i])
              }
            }
          })
        } else {
          this.sensitiveWord = []
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  mounted() {
    this.getOnlineStudent()
    this.getStudy()
    this.getExam()
    this.getDiscussList()
    this.getSurveyInfo()
    this.getStudyProgress()
    this.getSensitiveWord()
  }
}
</script>

<style lang="less" scoped>
@font-face {
  font-family: "iconfont"; /* Project id 2771525 */
  src: url("//at.alicdn.com/t/font_2771525_nchhf43gehs.woff2?t=1637224420650")
      format("woff2"),
    url("//at.alicdn.com/t/font_2771525_nchhf43gehs.woff?t=1637224420650")
      format("woff"),
    url("//at.alicdn.com/t/font_2771525_nchhf43gehs.ttf?t=1637224420650")
      format("truetype");
}

.center {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  padding-bottom: 110px;
}

.list {
  width: 100%;
  background: #f4f4f4;
  padding: 10px;
  margin-top: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  box-sizing: border-box;

  .pic-wrap {
    width: 180px;
    height: 101px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .desc-wrap {
    width: 50%;
    margin-left: 20px;

    .p1 {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .p2 {
      font-size: 12px;
      color: #999;
      margin-bottom: 10px;

      span {
        margin-right: 10px;

        &:nth-child(2) {
          color: #e19931;
        }
      }
    }
  }
}

.progress-time {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .begin-study {
    background-color: #73D6CA;
    color: #fff;
    padding: 10px 15px;
    border-radius: 5px;
    margin-left: 20px;
    cursor: pointer;
  }
}

.progress-bg {
  width: 50%;
  background-color: #ddd;
  border-radius: 15px;
  margin-right: 20px;
  overflow: hidden;
}

.skills {
  text-align: right;
  line-height: 20px;
  color: white;
  border-radius: 15px;
}

.progress {
  width: 20%;
  height: 20px;
  background-color: #4caf50;
}

// 导航切换
.switch-tab {
  width: 100%;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  margin-top: 20px;

  li {
    display: inline-block;
    width: 200px;
    height: 42px;
    font-size: 15px;
    color: #666;
    line-height: 42px;
    text-align: center;
    cursor: pointer;
  }

  li.active {
    background: #73D6CA;
    color: #fff;
  }
}

.content {
  margin-top: 20px;
  min-height: 450px;
}

// 课程简介
.brief {
  font-size: 14px;
  color: #555;
  line-height: 30px;

  /deep/ p {
    text-indent: 2em;
    margin-bottom: 10px;
    text-align: justify;
  }
}

// 学习评价
.evaluate {
  font-size: 14px;
  color: #555;
  line-height: 30px;

  /deep/ p {
    text-indent: 2em;
    margin-bottom: 10px;
    text-align: justify;
  }
}

// 学习提醒
.remind {
  #list {
    .edit {
      text-decoration: none;
    }
  }
}

// 讨论答疑
.discuss {
  .operation {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .operation-left {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .operation-tab {
        margin-right: 20px;

        div {
          display: inline-block;
          width: 70px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          border: 1px solid #eee;
          color: #555;
          cursor: pointer;

          &:nth-child(1) {
            border-right: none;
          }
        }

        div.active {
          background: #25c7a8;
          border-color: #25c7a8;
          color: #fff;
        }
      }

      .operation-search {
        width: 200px;
        height: 30px;
        border: 1px solid #eee;

        input {
          border: none;
          width: 150px;
          height: 28px;
          color: #555;
          outline: none;
          padding-left: 10px;
          box-sizing: border-box;
        }

        span {
          display: inline-block;
          line-height: 30px;
          height: 30px;
          background: #eee;
          color: #555;
          width: 50px;
          text-align: center;
          cursor: pointer;
        }
      }
    }

    .operation-btn {
      width: 80px;
      height: 30px;
      background: #25c7a8;
      color: #fff;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
  }

  .discuss-content {
    .posts {
      margin-top: 50px;
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;

      h6 {
        font-size: 15px;
        color: #555;
        margin-bottom: 20px;
        cursor: pointer;
      }

      .posts-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        color: #999;

        > div {
          span {
            margin-right: 20px;
          }
        }
      }
    }
  }

  .discuss-reply {
    margin-top: 30px;

    .discuss-main {
      font-size: 14px;
      color: #555;

      .discuss-main-title,
      .discuss-main-tips {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .discuss-main-title {
        border-bottom: 1px solid #eee;
        padding-bottom: 10px;
        margin-bottom: 20px;

        .praise {
          cursor: pointer;

          i {
            margin-right: 10px;
          }
        }
      }

      .discuss-main-content {
        margin-bottom: 30px;
      }

      .discuss-main-tips {
        > div {
          span {
            margin-right: 20px;
          }
        }

        > span {
          padding: 5px 10px;
          color: #fff;
          background: #25c7a8;
          border-radius: 5px;
          cursor: pointer;
        }
      }

      .discuss-main-count {
        width: 100%;
        height: 50px;
        line-height: 50px;
        border: 1px solid #eee;
        padding-left: 50px;
        box-sizing: border-box;
        background: #f9f9f9;
        margin-top: 30px;
      }
    }

    .posts-info {
      width: 95%;
      font-size: 14px;
      color: #555;
      margin-left: 20px;
      padding-bottom: 20px;
      border-bottom: 1px solid #eee;

      li {
        border-bottom: 1px solid #eee;
        padding: 0 10px;
        padding-bottom: 20px;
      }

      .posts-info-content {
        margin: 20px 0;
      }

      .posts-info-tips {
        display: flex;
        justify-content: space-between;
        align-items: center;

        > div {
          &:first-child {
            span {
              margin-right: 20px;
            }
          }
        }

        .praise {
          display: inline-block;
          cursor: pointer;

          i {
            margin-right: 5px;
          }
        }

        .reply {
          display: inline-block;
          margin-left: 20px;
          cursor: pointer;
        }
      }
    }
  }
}

.reply-main {
  width: 100%;
  min-height: 50px;
  background: #efefef;
  margin: 30px auto 0;
  padding: 10px 30px;
  position: relative;
  margin-bottom: 20px;
  box-sizing: border-box;

  > div {
    width: 90%;
    position: relative;
    min-height: 50px;
    padding: 20px 0;
    box-sizing: border-box;

    > div {
      width: 80%;
      min-height: 30px;
      margin: 0 auto;
    }
  }

  .iconfont {
    color: #cfe1e4;
    font-size: 30px;
    position: absolute;
  }

  .icon-left {
    left: 0;
    top: 0;
  }

  .icon-right {
    right: 0;
    bottom: 0;
  }
}

// 学习
.container-wrap {
  display: flex;
  background: #fff;
  min-height: 500px;
  .sub-group {
    flex: 1;
  }
  .menu-list {
    display: inline-block;
    width: 400px;
    border: 1px solid #eee;
    .tags-lines {
      display: flex;
      height: 40px;
      background: #f1f1f1;
      .tags-item {
        text-align: center;
        width: calc(100% / 5);
        color: #333;
        cursor: pointer;
        span {
          line-height: 40px;
        }
      }
      .tags-Active {
        background: #73D6CA;
        color: #fff;
      }
    }
    .field {
      background: #fff;
      height: 500px;
      overflow-y: scroll;
      .field-item {
        color: #333;
        border-bottom: 1px solid #eee;
        padding: 15px;
        cursor: pointer;
        .theoryBg {
          background-color: #73D6CA;
        }
        .expBg {
          background-color: #109900;
        }
        img {
          width: 18px;
          position: relative;
          top: 4px;
          margin-right: 4px;
        }
        .label {
          color: #fff;
          padding: 4px 10px;
          font-size: 12px;
          margin-left: 10px;
        }
        .name {
          display: inline-block;
          position: relative;
          top: 4px;
          max-width: 260px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .field-Active {
        color: #ffc600;
      }
      .tips {
        margin-top: 100px;
        color: #666;
        text-align: center;
      }
    }
  }
  .container {
    display: inline-block;
  }
}

.list-question {
  h2 {
    text-align: center;
  }
  .question-title {
    font-size: 18px;
    display: inline-block;
  }
  .question-del {
    border: 1px solid indianred;
    border-radius: 3px;
    padding: 2px 4px;
    color: indianred;
    float: right;
  }
  .question-list {
    margin: 10px 10px 30px 10px;
  }
  .question-list > li {
    font-size: 16px;
    margin: 4px;
    input {
      margin-right: 5px;
    }
  }
}
.footer-btn {
  text-align: center;
  .add-btn {
    padding-left: 15px;
    padding-right: 15px;
  }
}
.section {
  li {
    color: #555;
    .section-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 40px;
      padding: 0 40px;
      background: #f7f7f7;
      .progress-bg {
        width: 20%;
        position: relative;
        span {
          font-size: 12px;
          position: absolute;
          left: 5px;
          top: 50%;
          transform: translateY(-50%);
          line-height: 0;
        }
        .progress {
          padding: 0;
          height: 15px;
        }
      }
    }
    .section-title,
    .section-discuss,
    .section-homework,
    .section-study,
    .section-test {
      font-size: 14px;
      border-bottom: 1px solid #eee;
      &:hover {
        background: #f0f9f9;
      }
    }
    .section-discuss,
    .section-homework,
    .section-study,
    .section-test {
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 40px;
      padding: 0 60px;
      .grade {
        span {
          margin-left: 40px;
        }
      }
    }
    .no-more {
      justify-content: center;
    }
  }
}
.list-title {
  display: block;
  background: #eee;
  padding-left: 5px;
  line-height: 30px;
  color: #999;
}
</style>
